module.exports = __webpack_public_path__ + "img/pztype-2.f8fe77a7.png";